import store from 'store';
import actions from 'store/actions/courier';

export const getCourier = async (queryString) => {
  return store().dispatch(actions.getCourier(queryString));
};

export const getZones = async (payload) => {
  return store().dispatch(actions.getZones(payload));
};

export const getCourierDashboardInfo = async (payload) => {
  return actions.getCourierDashboardInfo(payload);
};

export const getCourierGpsData = async (payload) => {
  return actions.getCourierGpsData(payload);
};

export const getCourierById = async (id) => {
  return store().dispatch(actions.getCourierById(id));
};

export const putCourierDocument = (payload) => {
  return actions.putCourierDocument(payload);
};

export const editCourier = async (payload) => {
  return store().dispatch(actions.editCourier(payload));
};

export const addCourier = async (data) => {
  return store().dispatch(actions.addCourier(data));
};

export const changeCourierStatus = async (data) => {
  return store().dispatch(actions.changeCourierStatus(data));
};

export const getAllCouriers = async (data) => {
  return store().dispatch(actions.getAllCouriers(data));
};

export const getZonesByStoreId = async (payload) => {
  return actions.getZonesByStoreId(payload);
};

export const getDownloadLinkForCourier = () => {
  return actions.getDownloadLinkForCourier();
};

export const getCourierTrackingDetails = async (phoneNumber) => {
  return actions.getCourierTrackingDetails(phoneNumber);
};

export const getCourierWithFilter = async (payload, queryString) => {
  return actions.getCourierWithFilter(payload, queryString);
};

export const getCourierApplications = async (queryString) => {
  return actions.getCourierApplications(queryString);
};

export const getFilteredCourierApplications = async (queryString) => {
  return actions.getFilteredCourierApplications(queryString);
};

export const getCities = () => {
  return actions.getCities();
};

export const getDistricts = async (queryString) => {
  return actions.getDistricts(queryString);
};

export const getNeighbourhoods = async (queryString) => {
  return actions.getNeighbourhoods(queryString);
};

export const getCouriers = async (queryString) => {
  return actions.getCouriers(queryString);
};

export const putCourierApprovalStatus = async (id, status) => {
  return actions.putCourierApprovalStatus(id, status);
};

export const rejectCourierApprovalStatus = async (id) => {
  return actions.rejectCourierApprovalStatus(id);
};

export const downloadAllDocuments = async (id) => {
  return actions.downloadAllDocuments(id);
};